import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import { axiosClient } from '../../../../library/Service/axiosClient';
import Swal from 'sweetalert2';

function SendMessage(props: any) {
  const [show, setShow] = useState(false);
  const [subject, setSubject] = useState('');
  const [cc, setCc] = useState('');
  const [message, setMessage] = useState('');
  const [attachment, setAttachment] = useState<File | null>(null);
  const [imageLink, setImageLink] = useState('');
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
      // Defensive check
  if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
    return;
  }

  const file = e.target.files[0];

  if (!file || typeof file.type !== 'string') {
    return; // Extra safety
  }
  
    //const file = files[0];
  
    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];
  
    const maxSizeInMB = 5;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  
    if (!allowedTypes.includes(file.type)) {
      alert('Invalid file type. Only PDF, JPG, JPEG, PNG, DOC, and DOCX are allowed.');
      e.target.value = ''; // Reset input
      return;
    }
  
    if (file.size > maxSizeInBytes) {
      alert(`File size should be less than or equal to ${maxSizeInMB} MB.`);
      e.target.value = '';
      return;
    }
  
    const apiUrl = `${process.env.REACT_APP_BROADCAST_SERVER}/upload/get-attached`;
    const formData = new FormData();
    formData.append('pdf_doc', file);
  
    try {
      const response = await axiosClient().post(apiUrl, formData);
      const link = response.data.link;
      setImageLink(link);
    } catch (error: any) {
      console.error('Upload failed:', error);
      alert('File upload failed. Please try again.');
    }
  };
  
  

    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();

      if (isSubmitting) return; // prevent double submission

      if (!subject.trim()) {
        alert('Subject is required.');
        return;
      }

      const ccList = cc
        .split(',')
        .map(email => email.trim())
        .filter(email => email.length > 0);

      const isValidEmail = (email: string): boolean =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      const invalidEmails = ccList.filter(email => !isValidEmail(email));

      if (invalidEmails.length > 0) {
        alert(`Invalid email(s): ${invalidEmails.join(', ')}`);
        return;
      }
    
      const formData = new FormData();
      formData.append('basid', props.basid);
      formData.append('subject', subject);
      formData.append('cc', ccList.join(',')); // or JSON.stringify if backend expects array
      formData.append('message', message);
    
      if (imageLink) {
        formData.append('attachment_url', imageLink); // 👈 send saved file URL
      }
    
      try {
        setIsSubmitting(true); // prevent re-clicking
        //const response = await axiosClient().post(`${process.env.REACT_APP_ADMIN_API_SERVER}/institute/createContacts`, {...data, id,groupId});
        const response = await axiosClient().post(`${process.env.REACT_APP_BAS_API}/counsellorsession/sd-send-mail`, formData);
        // alert(response.data.message || 'Message sent successfully!');
        await Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message || 'Message sent successfully!',
        });
        setShow(false);
        window.location.reload();  // Refresh the page
      } catch (error: any) {
        console.log("error: ", error);
        // alert('Failed to send message.');
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error ? `${error?.message}` : 'Failed to send message.',
        });
        console.error(error);
      } finally {
        setIsSubmitting(false); // reset state
      }
    };
      

  return (
    <>
      <button className={props.className} onClick={handleShow}>
        <span>{props.btnText}</span>
      </button>

      <Modal show={show} onHide={handleClose} centered className='bg-dark bg-opacity-75' size="xl">
        <Modal.Header closeButton className='px-4'>
          <Modal.Title>Send Message</Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-4'>
          <form className="row g-3" onSubmit={handleSubmit}>
            <div className="col-12">
              <input type="hidden" value={props.basid} />
            </div>

            <div className="col-12">
              <label className="form-label">Email Subject</label>
              <input type="text" className="form-control" value={subject} onChange={(e) => setSubject(e.target.value)} />
            </div>

            <div className="col-12">
              <label className="form-label">Email CC</label>
              <input
                type="text"
                className="form-control"
                value={cc}
                onChange={(e) => setCc(e.target.value)}
                placeholder="Enter multiple emails, separated by commas"
              />
            </div>

            <div className="col-md-12 messagewrap textarea-cnt">
              <label className="form-label">Email Body</label>
              <ReactQuill value={message} onChange={setMessage} placeholder="Compose your message..." />
            </div>

            <div className="col-12">
              <label className="form-label">Email Attachment : </label>
              {/* <input type="file" onChange={handleImageUpload} /> */}
              <div className="upload_section">
                <input type="file" id="cloud-computing" className="" onChange={handleImageUpload} />
                  <div className="row g-2 align-items-center justify-content-center">
                    <div className="col-sm d-flex align-items-center justify-content-center">
                      <div className="cloud-wrap px-3 px-sm-5 mx-auto">
                        <div className="cloud-img"><img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/cloud-computing.svg`} alt="" /></div>
                        <div className="cloud-text">Drag and drop here or <a href="javascript:;" className="text-sky-blue">Browse</a></div>
                      </div>                          
                    </div>
                    
                  </div>
              </div>
              {/* <input type="file" onChange={(e) => setAttachment(e.target.files?.[0] || null)} /> */}
            </div>
            {imageLink && (
              <div className="col-12">
                <small className="text-success"> File uploaded: <a href={imageLink} target="_blank" rel="noopener noreferrer">{imageLink}</a></small>
              </div>
            )}



            <div className="col-auto">
            <button type="submit" className="btn btn-green" disabled={isSubmitting}>
              <span>{isSubmitting ? 'Submitting...' : 'Submit'}</span>
            </button>
              {/* <button type="submit" className="btn btn-green"><span>Submit</span></button> */}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SendMessage;
